<template>
  <QCard
    :class="[
      'login-card column',
      { 'full-height': flat, 'full-width': fullWidth }
    ]"
    :flat="flat"
  >
    <QCardSection :class="{ 'q-pa-lg': flat }">
      <div
        :class="[
          'q-mb-lg row justify-between items-center',
          { 'q-mt-md': !flat }
        ]"
        v-if="$slots.header"
      >
        <slot name="header" />
        <QBtn
          v-if="$listeners.close"
          icon="eva-close-outline"
          color="grey-8"
          round
          flat
          dense
          :ripple="false"
          size="12px"
          @click="$emit('close', $event)"
        />
      </div>
      <slot />
    </QCardSection>
    <QSpace />
    <QCardActions
      v-if="$slots.footer"
      class="q-pa-md bdr-t-grey-3 column justify-center"
    >
      <slot name="footer" />
    </QCardActions>
  </QCard>
</template>

<script>
import { QCard, QCardActions, QCardSection, QSpace, QBtn } from 'quasar';

export default {
  name: 'LoginCard',
  props: {
    flat: Boolean,
    fullWidth: {
      type: Boolean,
      default: true
    }
  },
  components: {
    QCard,
    QCardActions,
    QCardSection,
    QSpace,
    QBtn
  }
};
</script>

<style lang="sass" scoped>
.login-card
    box-shadow: 0 2pt 16pt 0 rgba(0, 0, 0, 0.15)
    border: 1px solid $grey-3
</style>
